export default {
  "retentionRate.title": "留存率",
  "retentionRate.column.no": "#NO",
  "retentionRate.column.statisticsTime": "日期",
  "retentionRate.column.registerNum": "注册用户数",
  "retentionRate.search.statisticsTime": "日期",
  "retentionRate.column.id": "ID",
  "retentionRate.column.registerCount": "注册数",
  "retentionRate.column.firstDepositCount": "首存数",
  "retentionRate.column.secondDayDepositCount": "次日首存数",
  "retentionRate.column.depositRetainRate": "存款留存率",
  "retentionRate.column.secondDayPlayerCount": "次日玩家数",
  "retentionRate.column.retainRate": "留存率",
  "retentionRate.column.secondDayRetainCount": "次日留存数",
  "retentionRate.column.playerRetainRate": "玩家留存率",
  "retentionRate.column.thirdDayRetainCount": "3日留存数",
  "retentionRate.column.fourthDayRetainCount": "4日留存数",
  "retentionRate.column.fifthSeventhDayRetainCount": "5-7日留存数",
  "retentionRate.column.eighthThirtyDayRetainCount": "8-30日留存数",
  "retentionRate.column.thirtyDayRetainCount": "30日留存数",
  "retentionRate.column.statisticsTimezoneName": "统计时区",
  "retentionRate.column.statisticsTimeDesc": "统计时间",
  "retentionRate.column.action": "操作",
  "retentionRate.column.details": "详情",
  "retentionRate.search.statisticsTimezone": "统计时区",
  "retentionRate.search.statisticsTimeDesc": "统计时间",
  "retentionRate.column.statisticsTo": "统计时间",
  "retentionRate.column.statisticsFrom": "统计时间",

};